import { makeStyles } from "@material-ui/core";

const useQuestionStyles = makeStyles({
    questionText: {
        color: "#000",
        opacity: 0.5,
        wordBreak: "normal",
    },
    mandatory: {
        color: "red",
        marginLeft: 4,
    },
    inputLabel: {
        fontSize: "14px",
        maxWidth: "90%",
    },
    input: {
        padding: "8px",
    },
    tooltip: {
        color: "#888",
        fontSize: 11,
        marginBottom: 4,
        display: "block",
    },
    spaceBetweenButtons : {
        marginRight: 8,
    }
});

export default useQuestionStyles;
